module.exports = __webpack_public_path__ + "img/github.ac7a5aba.svg";